var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { Children, useRef, useState } from 'react';
import Slider from 'react-slick';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, IconButton } from '@mui/material';
import omit from 'lodash/omit';
var GBSlider = function (_a) {
    var _b, _c;
    var sliderProps = _a.sliderProps, children = _a.children, slideContainerClasses = _a.slideContainerClasses, activeDotColor = _a.activeDotColor, dotColor = _a.dotColor, setCurrentSlide = _a.setCurrentSlide, onDotClick = _a.onDotClick, onRightArrowClick = _a.onRightArrowClick, onLeftArrowClick = _a.onLeftArrowClick, slidesToScrollCallbackCondition = _a.slidesToScrollCallbackCondition, source = _a.source, arrowPlacement = _a.arrowPlacement, sliderTopBoxContainerStyles = _a.sliderTopBoxContainerStyles, src = _a.src;
    var sliderRef = useRef(null);
    var _d = __read(useState(0), 2), currentPage = _d[0], setCurrentPage = _d[1];
    var handleNavigation = function (direction) {
        var _a, _b;
        if (direction === 'left') {
            onLeftArrowClick === null || onLeftArrowClick === void 0 ? void 0 : onLeftArrowClick();
            (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickPrev();
        }
        else {
            onRightArrowClick === null || onRightArrowClick === void 0 ? void 0 : onRightArrowClick();
            (_b = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _b === void 0 ? void 0 : _b.slickNext();
        }
    };
    return (React.createElement(Box, { sx: __assign({
            position: 'relative',
            zIndex: 2,
            px: 2,
            '& .slick-arrow': { display: 'none !important' },
            '& .slick-dots': {
                bottom: '-35px',
                li: { width: 'auto' },
                '& .slick-active': {
                    div: {
                        backgroundColor: "".concat(activeDotColor !== null && activeDotColor !== void 0 ? activeDotColor : '#BEBBFF', " !important")
                    }
                }
            },
            '& .slick-track': {
                display: 'flex !important',
                '.slick-slide': __assign({ margin: '0 8px', 'div:first-child': {
                        height: '100%'
                    } }, slideContainerClasses)
            }
        }, sliderTopBoxContainerStyles) },
        Children.count(children) > ((_c = (_b = sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.slidesToShow) !== null && _b !== void 0 ? _b : sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.slidesPerRow) !== null && _c !== void 0 ? _c : 1) && (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { onClick: function () {
                    handleNavigation('left');
                }, className: "lfc-absolute lfc-rounded-lg lfc-shadow-lg lfc-z-[500] ".concat(arrowPlacement === 'bottom-right' ? 'lfc-bottom-0 lfc-right-[48px]' : 'lfc-bottom-[50%] -lfc-left-[8px]', " lfc-translate-y-[50%] lfc-bg-white") },
                React.createElement(KeyboardArrowLeftIcon, null)),
            React.createElement(IconButton, { onClick: function () {
                    handleNavigation('right');
                }, className: "lfc-absolute lfc-rounded-lg lfc-shadow-lg lfc-z-[500] ".concat(arrowPlacement === 'bottom-right' ? 'lfc-bottom-0 -lfc-right-[4px]' : 'lfc-bottom-[50%] -lfc-right-[8px]', " lfc-translate-y-[50%] lfc-bg-white") },
                React.createElement(KeyboardArrowRightIcon, null)))),
        React.createElement(Slider, __assign({ ref: sliderRef, dots: true, customPaging: function () { return React.createElement("div", { className: "lfc-w-2 lfc-h-2 lfc-rounded-full ".concat(dotColor !== null && dotColor !== void 0 ? dotColor : 'lfc-bg-gray-500') }); }, afterChange: function (currentSlide) {
                setCurrentSlide === null || setCurrentSlide === void 0 ? void 0 : setCurrentSlide(currentSlide);
                setCurrentPage(currentSlide);
            }, slidesToScroll: slidesToScrollCallbackCondition === null || slidesToScrollCallbackCondition === void 0 ? void 0 : slidesToScrollCallbackCondition(currentPage) }, omit(sliderProps, ['slidesToScroll'])), children)));
};
export default GBSlider;
//# sourceMappingURL=Slider.js.map